import { useTranslation } from 'react-i18next';

export default function AboutSection() {
  const { t } = useTranslation('common');
  
  return (
    <section id="about" className="py-24 lg:py-32 relative">
      <div className="absolute inset-0 bg-cover bg-center" style={{ backgroundImage: 'url(https://static.readdy.ai/image/c07ed6529feea951012003251bff6ba4/78a627228f114a68e878a20237e5938e.jpeg)' }}></div>
      <div className="absolute inset-0 bg-black/70"></div>
      <div className="max-w-7xl mx-auto px-6 lg:px-8 relative z-10">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="text-sm font-semibold text-[#4d9c71] uppercase tracking-wider mb-4 whitespace-nowrap">
            {t('about.sectionTitle')}
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-white mb-6">
            {t('about.title')}
          </h2>
          <p className="text-lg text-gray-200 max-w-3xl mx-auto">
            {t('about.subtitle')}
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Left - Image */}
          <div className="relative">
            <div className="w-full h-[500px] rounded-3xl overflow-hidden">
              <img 
                src="https://public.readdy.ai/ai/img_res/03919cee12723aba1c9b3a54c17759a6.jpg"
                alt="IT Team"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>

          {/* Right - Content */}
          <AboutContent />
        </div>
      </div>
    </section>
  );
}

function AboutContent() {
  const { t } = useTranslation('common');

  return (
    <div>
      <div className="text-sm font-semibold text-[#4d9c71] uppercase tracking-wider mb-4 whitespace-nowrap">
        {t('about.sectionTitle')}
      </div>
      <h2 className="text-4xl lg:text-5xl font-bold text-white mb-6">
        {t('about.title')}
      </h2>
      <p className="text-lg text-gray-200 mb-6 leading-relaxed">
        {t('about.description')}
      </p>
      <p className="text-lg text-gray-200 mb-8 leading-relaxed">
        {t('about.mission')}
      </p>

      {/* Tags */}
      <div className="flex flex-wrap gap-3 mt-8">
        <span className="px-4 py-2 rounded-full border border-[#4d9c71] text-[#4d9c71] text-sm font-medium whitespace-nowrap">
          {t('about.gdprCompliant')}
        </span>
        <span className="px-4 py-2 rounded-full border border-[#4d9c71] text-[#4d9c71] text-sm font-medium whitespace-nowrap">
          {t('about.support247')}
        </span>
      </div>
    </div>
  );
}
